"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteManualCommitmentResponseToJSON = exports.DeleteManualCommitmentResponseFromJSONTyped = exports.DeleteManualCommitmentResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function DeleteManualCommitmentResponseFromJSON(json) {
    return DeleteManualCommitmentResponseFromJSONTyped(json, false);
}
exports.DeleteManualCommitmentResponseFromJSON = DeleteManualCommitmentResponseFromJSON;
function DeleteManualCommitmentResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'success': !(0, runtime_1.exists)(json, 'success') ? undefined : json['success'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
        'deletedAmount': !(0, runtime_1.exists)(json, 'deletedAmount') ? undefined : json['deletedAmount'],
        'newTotalCredits': !(0, runtime_1.exists)(json, 'newTotalCredits') ? undefined : json['newTotalCredits'],
    };
}
exports.DeleteManualCommitmentResponseFromJSONTyped = DeleteManualCommitmentResponseFromJSONTyped;
function DeleteManualCommitmentResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'success': value.success,
        'message': value.message,
        'deletedAmount': value.deletedAmount,
        'newTotalCredits': value.newTotalCredits,
    };
}
exports.DeleteManualCommitmentResponseToJSON = DeleteManualCommitmentResponseToJSON;
